import React from 'react';
import { setDataAttributes } from '../util/getDataAttributes';
import { StyledCharLimit, StyledHintArea } from './Hint.styled';
export function Hint(props) {
  if ((!props.showCharacterLimit || !props.maxLength) && !props.hint) {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledHintArea, setDataAttributes(props, 'hint'), /*#__PURE__*/React.createElement("div", null, props.hint), props.showCharacterLimit && props.maxLength && /*#__PURE__*/React.createElement(StyledCharLimit, null, "".concat(props.currentLength || 0, "/").concat(props.maxLength)));
}